export default "/assets/website/images/szechenyi.jpg?982ef70f527fc8a1437a4e9d06c4bafe";